import { Fancybox } from "@fancyapps/ui";
var HeroBlock = /** @class */ (function () {
    function HeroBlock(element) {
        this.heroBlock = element;
        this.contentContainer = this.heroBlock.querySelector('.container');
        this.video = this.heroBlock.querySelector('.hero-video');
        this.videoThumbnail = this.heroBlock.querySelector('.video-thumbnail');
        this.videoToggle = this.heroBlock.querySelector('[data-hero-video]');
        this.scrollDownButton = this.heroBlock.querySelector('.hero-scroll-down');
        this.nextSection = this.heroBlock.nextElementSibling;
        this.body = document.querySelector('body');
        this.header = document.querySelector('.header');
        this.pageOverlay = document.querySelector('[data-page-overlay]');
        this.pageLoader = document.querySelector('[data-page-loader]');
        this.addEventListeners();
    }
    HeroBlock.prototype.addEventListeners = function () {
        var _this = this;
        // wait for document to load and then calculate height
        document.addEventListener('DOMContentLoaded', function () {
            if (_this.videoThumbnail && _this.video) {
                _this.loadVideo();
            }
            var contentContainerHeight = _this.contentContainer.offsetHeight;
            var headerHeight = _this.header.offsetHeight;
            _this.heroBlock.style.setProperty('--hb-mh', "".concat(contentContainerHeight, "px"));
            _this.observer();
        });
        if (this.videoToggle) {
            this.videoToggle.addEventListener('click', this.onVideoButtonToggle.bind(this));
        }
        if (this.scrollDownButton) {
            // Check if scroll down button exists
            this.scrollDownButton.addEventListener('click', function () { return _this.nextSection.scrollIntoView({ behavior: 'smooth' }); });
        }
    };
    HeroBlock.prototype.loadVideo = function () {
        var _this = this;
        this.video.classList.remove('hidden');
        this.video.classList.add('reveal');
        this.videoThumbnail.classList.add('reveal');
        this.video.classList.remove('reveal');
        this.videoThumbnail.classList.add('hidden');
        // set 0.5s timeout to allow for fade out animation
        setTimeout(function () {
            _this.videoThumbnail.remove();
        }, 500);
    };
    HeroBlock.prototype.observer = function () {
        var contentElement = this.heroBlock;
        function onVisibilityChange(entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    contentElement.classList.remove('scrolled');
                }
                else {
                    contentElement.classList.add('scrolled');
                }
            });
        }
        var observerOptions = {
            root: null, // Use the viewport as the root
            rootMargin: '0px',
            threshold: 0.1 // Trigger callback when at least 10% of the element is visible
        };
        var observer = new IntersectionObserver(onVisibilityChange, observerOptions);
        observer.observe(contentElement);
    };
    HeroBlock.prototype.onVideoButtonToggle = function (event) {
        var _this = this;
        var videoSrc = this.videoToggle.dataset.heroVideo;
        if (videoSrc) {
            // Check if video source is set
            this.body.classList.add('no-scroll');
            this.pageOverlay.classList.add('visible');
            this.pageLoader.classList.add('active');
            var fancybox = new Fancybox([
                {
                    src: videoSrc,
                    // @ts-ignore
                    type: "html5video"
                },
            ]);
            fancybox.on('done', function (fancybox) {
                _this.body.classList.remove('no-scroll');
                _this.pageOverlay.classList.remove('visible');
                _this.pageLoader.classList.remove('active');
            });
        }
    };
    return HeroBlock;
}());
var heroBlocks = document.querySelectorAll('[data-hero-block]');
heroBlocks.forEach(function (heroBlock) {
    new HeroBlock(heroBlock);
});
